module.exports = __webpack_public_path__ + "img/album02_04.91426361.jpg";